import * as Sentry from '@sentry/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import SignIn from './components/sign-in/sign-in'

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
import ProtectedRoutes from './ProtectedRoute';
import { useAnalyticsPageView } from './hooks';
import './App.css';

// Wrapper component to enable page view tracking inside Router context
function PageViewTracker({ children }) {
  useAnalyticsPageView();
  return children;
}

function App() {

  return (
    <BrowserRouter basename="/">
      <PageViewTracker>
        <SentryRoutes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/*" element={<ProtectedRoutes />} />
        </SentryRoutes>
      </PageViewTracker>
    </BrowserRouter>
  );
}

export default App;
